import { Experiments } from './experiments.models';
import { getExperimentsFromUrl } from './get-experiments-from-url';
import { getExperimentsFromServer } from './transport/experiments-service';

const defaultExperiments: Experiments = {};

let experiments: Experiments = defaultExperiments;

export function isExperimentActive(experimentName: string): boolean {
  return experiments[experimentName] === 'true';
}

export function setExperiments(newExperiments: Experiments): Experiments {
  experiments = { ...defaultExperiments, ...newExperiments };
  return experiments;
}

export function getExperiments(): Experiments {
  return experiments;
}

export function fetchExperiments(): any {
  const experimentsFromUrl = getExperimentsFromUrl();

  return getExperimentsFromServer().then(
    (response) => ({ ...response.data, ...experimentsFromUrl }),

    () => {
      console.warn(
        'Cannot fetch the experiments from server. Set the default experiments and experiments from url.',
      );
      return experimentsFromUrl;
    },
  );
}
